/**
 * Styled Components - Created by Jesús Apodaca on 21/02/20.
 */
import styled from 'styled-components'
import InputNumber from 'antd/lib/input-number'
import Icon from 'antd/lib/icon'
import { GRAY_DARK, RED, GRAY } from '../../../theme/colors'

interface IconProps {
  invert?: boolean
  enabled?: boolean
}

interface DivProps {
  maxWidth?: boolean
  alignStart?: boolean
  noMargin?: boolean
  secondary?: boolean
}

export const Container = styled.div`
  margin: 0px 32px;
  padding: 12px 2px;
  margin-bottom: 28px;
  margin-right: 18px;
  gap-column: 6px;
`

export const Title = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`

export const NumberInput = styled(InputNumber)`
  width: 100%;
  margin-top: 4px;
  .ant-input-number-handler-wrap {
    opacity: 1;
  }
  .ant-input-number-input-wrap {
    font-size: 14px;
  }
`

export const InputContainer = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 0px;
  @media (min-width: 1820px) {
    justify-content: flex-start;
  }
`

export const InputBlock = styled.div`
  display: flex;
  flex-flow: column;
  margin-right: ${({ noMargin }: DivProps) => (noMargin ? '0' : '16px')};
  justify-content: flex-start;
  align-items: flex-start;
  max-width: ${({ secondary }: DivProps) => secondary ? '64px' : '88px'};
  width: 100%;
  &:last-child {
    margin-right: 0px;
  }
  @media (min-width: 1524px) {
    margin-right: ${({ noMargin }: DivProps) => (noMargin ? '0' : '20px')};
    max-width: ${({ secondary }: DivProps) => secondary ? '80px' : '100px'};
  }
`

export const InputBlockShort = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 74px;
  margin-bottom: 0px;
`

export const Subtitle = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 12px;
`

export const AdjustButtonTitle = styled.div`
  font-size: 12px;
  font-family: Avenir;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const SmallIcon = styled(Icon)`
  font-size: 14px;
  margin-left: 4px;
  transform: rotate(
    ${({ invert }: IconProps) => (invert ? '-45deg' : '45deg')}
  );
`

export const LockIcon = styled(Icon)`
  margin: 16px 5px 0;
  cursor: pointer;
  font-size: 12px;
  color: ${({ enabled }: IconProps) => (enabled ? RED : GRAY)};
`

export const ControlButton = styled.img`
  max-width: 54px;
  height: 54px;
  margin-top: 3px;
  padding: 8px;
  border: 1px solid ${GRAY};
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    filter: invert(1) brightness(1.2);
    background: rgb(224, 224, 224);
  }
`

export const Separator = styled.div`
  border: solid 1px #efefef;
  height: 0.5px;
  margin-top: 10px;
  margin-bottom: 10px;
`

export const SwitchContainer = styled.div<{checked: boolean}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 58px;
  .ant-switch-inner {
    direction: ltr;
  }
  .ant-switch {
    width: 68px;
    height: 30px;
    background-color: #34C759;
    ::after {
      margin-top: 1px;
      width: 24px;
      height: 24px;
      padding-top: 4px;
      content: url("https://storage.googleapis.com/jakroo/clipart/${props => props.checked ? 'lock' : 'unlock'}.svg");
    }
  }
  .ant-switch-checked {
    background-color: #C91731;
  }
`
export const MultipleGraphic = styled.div`
  background: rgb(215, 209, 210);
  display: none;
  place-items: center;
  padding-left: 12px;
  padding-right: 12px;
  border-radius: 20px;
  width: 100%;
`

export const ControlInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  & > div:first-child {
    font-size: 12px;
    font-family: Avenir;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  width: 100%;
  max-width: 138px;
  @media (min-width: 769px) {
    max-width: 150px;
  }
`
export const ControlInput = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px;
  background-color: white;
  border: solid 1px #d7d1d2;
  border-radius: 4px;
  width: 100%;
  height: 40px;
`

export const Input = styled(InputNumber)`
  position: absolute;
  left: 28px;
  background-color: white;
  border: none;
  height: 38px;
  width: 75%;
  text-align: center;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  .ant-input-number-handler-wrap {
    display: none !important;
  }
  &:hover,
  &:focus,
  &.ant-input-number-focused {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }

  input {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    padding-left: 12px;
    padding-right: 32px;
    text-align: center; /* optional: center the text */
    padding-top: 8px;
  }
  /* Chrome, Safari, Edge, Opera */
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  height: 28px;
  width: 28px;
  border-radius: 4px;
  font-size: 14px;
  z-index: 999;
  background: #E8E5E5;
  &:hover {
    cursor: pointer;
  }
`

export const DeleteButton = styled.button`
  padding: 8px;
  border-radius: 20px;
  width: 100%;
  height: 42px;
  font-size: 14px;
  font-weight: 600;
  color: #C91731;
  background-color: white;
  border: solid 1.5px #C91731;
  margin-top: 12px;
  cursor: pointer;
  :hover {
    color: white;
    background-color: #c91731;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/PositionResize/styledComponents.tsx